import { render, staticRenderFns } from "./RelatedVehiclesComponent.vue?vue&type=template&id=4cc0a7f8"
import script from "./RelatedVehiclesComponent.vue?vue&type=script&lang=js"
export * from "./RelatedVehiclesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports